import { useEffect, useState } from "react";
import betwayFantasyLogo from "../../../../assets/bw_fantasyfootball.svg";
import bigPrizeImage from "../../../../assets/euphoria.jpg";
import howToPlayImage from "../../../../assets/how-to-play.png";
import CircularProgress from "./components/CircularProgress";
import styles from "./Welcome.module.css";

const Welcome = ({ onPlayClick }) => {
	// Set the target date: August 16, 2025, 15:00 CET
	const targetDate = new Date("2025-08-16T15:00:00+02:00");

	// State to track countdown time with safe default values
	const [timeLeft, setTimeLeft] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	});

	// Function to calculate time difference
	const calculateTimeLeft = () => {
		const now = new Date();
		const difference = targetDate.getTime() - now.getTime();

		// If past the target date, return zeros
		if (difference <= 0) {
			return {
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
			};
		}

		// Calculate time units
		const days = Math.floor(difference / (1000 * 60 * 60 * 24));
		const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((difference % (1000 * 60)) / 1000);

		return { days, hours, minutes, seconds };
	};

	// Countdown effect
	useEffect(() => {
		// Initial calculation
		setTimeLeft(calculateTimeLeft());

		// Set up the countdown interval
		const timer = setInterval(() => {
			setTimeLeft(calculateTimeLeft());
		}, 1000);

		// Clean up the interval on component unmount
		return () => clearInterval(timer);
	}, []);

	// Prize data
	const prizes = [
		{
			id: 1,
			title: "Grand Prize – Watch Arsenal at the Emirates Stadium",
			description:
				"Win a trip for two to watch Arsenal play at the Emirates Stadium in London, including flights (if required), accommodation (if required) and £500 spending money.",
			image: bigPrizeImage,
		},
		{
			id: 2,
			title: "Round Winner – Cash Prize in your Betway account",
			description:
				"The top performer every week will win €150 (or currency equivalent – see ‘Rules’ section) as Cash deposited into their Betway account.",
			image: bigPrizeImage,
		},
		{
			id: 3,
			title: "Places 2-10 every round – Cash Prize in your Betway account",
			description:
				"Those finishing 2nd to 10th every week will also receive Cash prizes in their Betway account. See the ‘Rules’ section for the exact amounts that you can win.",
			image: bigPrizeImage,
		},
	];

	// Handle the play button click
	const handlePlayClick = () => {
		// Call the passed in onPlayClick function
		if (onPlayClick) {
			onPlayClick();
		}
	};

	return (
		<div className={styles.pageContainer}>
			{/* Main scrollable content */}
			<div className={styles.scrollableContent}>
				{/* Prize Banners with Vertical Scroll */}
				<div className={styles.prizeBannerContainer}>
					{prizes.map((prize) => (
						<div key={prize.id} className={styles.prizeBanner}>
							<div className={styles.prizeContent}>
								<h2 className={styles.prizeTitle}>{prize.title}</h2>
								<p className={styles.prizeDescription}>{prize.description}</p>
							</div>
							<div className={styles.prizeWrapper}>
								<img className={styles.prizeImage} src={prize.image} alt="" />
							</div>
						</div>
					))}
				</div>

				{/* Fantasy Team Card */}
				<div className={styles.teamCard}>
					<div className={styles.fantasyLogo}>
						<img src={betwayFantasyLogo} alt="Betway Fantasy Football" />
					</div>
					<h2 className={styles.teamTitle}>Play BW Fantasy Football and win!</h2>
					<div className={styles.leagueLabel}>
						<span>The Biggest League in the World</span>
					</div>

					<p className={styles.teamDescription}>
						Simply select your BW Fantasy Football team every week before the start of the next round of fixtures. Besides the Grand Prize
						on offer for the season, the Top 10 performers every week will also win a cash prize. Rules and T&C’s apply.
					</p>

					<p className={styles.seasonNote}>
						The season starts on <strong>15 August 2025</strong>
					</p>

					{/* Countdown Timer */}
					<div className={styles.countdownContainer}>
						<CircularProgress value={timeLeft.days} maxValue={100} label="DAYS" size={60} />
						<CircularProgress value={timeLeft.hours} maxValue={24} label="HOURS" size={60} />
						<CircularProgress value={timeLeft.minutes} maxValue={60} label="MIN" size={60} />
						<CircularProgress value={timeLeft.seconds} maxValue={60} label="SEC" size={60} />
					</div>

					{/* Formation Pitch - Image Placeholder */}
					<div className={styles.formationContainer}>
						<div className={styles.pitchImagePlaceholder}>
							{/* Replace this div with your actual pitch image */}
							<img src={howToPlayImage} alt="Football pitch formation" />
						</div>
					</div>
				</div>

				{/* Add extra padding at the bottom to ensure content isn't hidden behind fixed button */}
				<div className={styles.buttonSpacer}></div>
			</div>

			{/* Fixed Play Now button */}
			<div className={styles.fixedButtonContainer}>
				<button className={styles.playNowButton} onClick={handlePlayClick}>
					Play Now
				</button>
			</div>
		</div>
	);
};

export default Welcome;
